/** Mirrors backend planning119/takanon-section-title.util.ts */
const TAKANON_SECTION_DISPLAY_TITLE: Record<string, string> = {
  section_3: 'זכויות והגבלות בנייה',
  section_4: 'תכליות מותרות',
  section_5: 'חניה',
  section_6: 'תשתיות',
  section_7: 'איכות סביבה',
};

const PLAN_REF_PREFIX =
  /^תמ["']?ל\s*\/?\s*[\dא-ת]+\s*[-–:]\s*/iu;
const SECTION_PREFIX = /^סעיף\s*[\dא-ת]+\s*[-–:.]\s*/iu;
const PLAN_IN_PLAN_SUFFIX = /\s*בתכנית\s+תמ["']?ל\s*\/?\s*[\dא-ת]+.*$/iu;
const PLAN_TRAILING = /\s*[-–:]\s*תמ["']?ל\s*\/?\s*[\dא-ת]+.*$/iu;

export function simplifyExtractedSectionTitle(raw?: string | null): string | undefined {
  if (!raw?.trim()) return undefined;
  let t = raw.trim();
  for (let i = 0; i < 4; i++) {
    const next = t
      .replace(PLAN_REF_PREFIX, '')
      .replace(SECTION_PREFIX, '')
      .replace(PLAN_IN_PLAN_SUFFIX, '')
      .replace(PLAN_TRAILING, '')
      .trim();
    if (next === t) break;
    t = next;
  }
  const slash = t.indexOf(' / ');
  if (slash > 0) {
    t = t.slice(0, slash).trim();
  }
  return t || undefined;
}

export function displayTitleForTakanonSection(
  sectionKey: string,
  modelTitle?: string | null,
): string {
  if (sectionKey in TAKANON_SECTION_DISPLAY_TITLE) {
    return TAKANON_SECTION_DISPLAY_TITLE[sectionKey];
  }
  return simplifyExtractedSectionTitle(modelTitle) ?? modelTitle?.trim() ?? sectionKey;
}
